import _ from 'lodash'
import { getCommonConfig } from '@/api/common'
import i18n from '@/lang'
import { allowedDisplayTrafficTypes } from '@pt/views/dashboard/config'
import { language } from '@/common/storage'

// const getLogo = (fileName) => require(`@com/assets/channel/${fileName}`)

export const WX_GAME_CHANNEL_ID = 34

// 渠道列表
export const channelList = []

// 交互素材：渠道列表
export const interactiveChannelList = []

// 非交互素材：渠道列表
export const nonInteractiveChannelList = []

// 非交互素材：渠道列表（msdk、dsp合并为Mintegral展示）
export const nonInteractiveWithMintegral = []

// 允许展示渠道options
export const trafficTypeOptions = []

// 是否已初始化
let isInitialized = false
// 初始化 Promise
let initPromise = null

function cookChannelList(channels) {
  const lang = language.get()
  return channels.map((channel) => ({
    ...channel,
    label: lang === 'zh-cn' ? channel.name_cn : channel.name_en,
    value: channel.id,
    ...(channel.id === 9
      ? {
          // 巨量引擎名称使用前端配置
          label: i18n.t(
            'playTurbo.picturesVideos.customized.filter.network.massive',
          ),
          // 巨量引擎非交互素材，增加别名alias
          alias: i18n.t(
            'playTurbo.picturesVideos.customized.filter.network.engine',
          ),
        }
      : {}),
  }))
}

// 获取渠道列表，初始化channelList、interactiveChannelList数据
const fetchChannelList = async () => {
  try {
    const res = await getCommonConfig({ names: 'all_channels' })
    // 不同仓库获取数据层级不同
    const dataKey = 'data.data.all_channels'
    const channels = cookChannelList(
      _.get(res, dataKey, []).map((channel) => ({
        ...channel,
        icon: channel.icon ? channel.icon : undefined,
      })),
    )
    // 更新渠道列表
    Object.assign(channelList, channels)
    // 更新交互素材渠道列表
    Object.assign(
      interactiveChannelList,
      _.cloneDeep(channelList.filter((item) => item.interactive)),
    )
    // 更新允许展示渠道options
    Object.assign(trafficTypeOptions, [
      {
        label: i18n.t('playTurbo.dashboard.filter.trafficType.all'),
        value: '',
      },
      ...allowedDisplayTrafficTypes
        .map((t) => channels.find((item) => item.value === t))
        .filter(Boolean)
        .map((item) => ({ label: item.label, value: item.value })),
    ])
    // 更新非交互素材渠道列表
    Object.assign(
      nonInteractiveChannelList,
      _.cloneDeep(channelList.filter((item) => item.noninteractive)),
    )
    // 更新非交互素材渠道列表（msdk、dsp合并为Mintegral展示）
    Object.assign(nonInteractiveWithMintegral, [
      ..._.cloneDeep(channelList.filter((item) => item.id === 21)),
      ..._.cloneDeep(
        channelList
          // 非交互渠道
          .filter((item) => item.noninteractive)
          // 排除msdk、dsp
          .filter((item) => ![1, 2].includes(item.id)),
      ),
    ])
    return channels
  } catch (error) {
    console.error('Failed to fetch channel list:', error)
    return []
  }
}

// 初始化渠道列表
export const initChannelList = () => {
  if (isInitialized) {
    return Promise.resolve(channelList)
  }

  if (initPromise) {
    return initPromise
  }

  initPromise = fetchChannelList().then((channels) => {
    isInitialized = true
    return channels
  })

  return initPromise
}

export function getChannelById(id, type = 'all') {
  if (type === 'interactive') {
    return interactiveChannelList.find((c) => c.value === id)
  }
  if (type === 'noninteractive') {
    return nonInteractiveChannelList.find((c) => c.value === id)
  }
  return channelList.find((c) => c.value === id)
}

// 获取渠道列表
export function getChannelsByType(type = 'all') {
  if (type === 'interactive') {
    return interactiveChannelList
  }
  if (type === 'noninteractive') {
    return nonInteractiveChannelList
  }
  return [...interactiveChannelList, ...nonInteractiveChannelList]
}

/**
 * 使用渠道值交换渠道 label
 * @param channelId {string|number|number[]}
 * @returns {string|*}
 */
export const useChannelIdExchangeChannelLabel = (channelId) => {
  if (_.isArray(channelId)) {
    return channelId
      .map((id) => {
        return (
          channelList.find((channel) => channel.value === Number(id)) || {}
        ).label
      })
      .join()
  }
  return (
    channelList.find((channel) => channel.value === Number(channelId)) || {}
  ).label
}
